"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = void 0;

var _react = _interopRequireDefault(require("react"));

var _usePrice2 = _interopRequireDefault(require("../../../hooks/usePrice"));

var _price = require("./price.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Price = function Price(_ref) {
  var priceRange = _ref.priceRange,
      _ref$measure = _ref.measure,
      measure = _ref$measure === void 0 ? 'md' : _ref$measure,
      _ref$$color = _ref.$color,
      $color = _ref$$color === void 0 ? 'gray800' : _ref$$color;

  var _usePrice = (0, _usePrice2.default)(),
      normalizePrice = _usePrice.normalizePrice;

  var _priceRange$minimum_p = priceRange.minimum_price,
      minFinalPrice = _priceRange$minimum_p.final_price,
      minRegularPrice = _priceRange$minimum_p.regular_price,
      _priceRange$maximum_p = priceRange.maximum_price,
      maxFinalPrice = _priceRange$maximum_p.final_price,
      maxRegularPrice = _priceRange$maximum_p.regular_price;
  var isSalePrice = minFinalPrice.value !== minRegularPrice.value;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isSalePrice ? /*#__PURE__*/_react.default.createElement(_price.PriceStyled, {
    measure: measure
  }, /*#__PURE__*/_react.default.createElement(_price.PriceItemStyled, {
    type: "old",
    size: measure
  }, normalizePrice(minRegularPrice.value, maxRegularPrice.value)), /*#__PURE__*/_react.default.createElement(_price.PriceItemStyled, {
    type: "final"
  }, normalizePrice(minFinalPrice.value, maxFinalPrice.value))) : /*#__PURE__*/_react.default.createElement(_price.PriceStyled, null, /*#__PURE__*/_react.default.createElement(_price.PriceItemStyled, {
    $color: $color
  }, normalizePrice(minRegularPrice.value, maxRegularPrice.value))));
};

exports.Price = Price;